/**
 * The words for a purchase invoice line whose cost is spread over a period
 * (Ben, 27 Oct 2026: "Spread over", once "Prepaid"). Every screen that names
 * the line's Spread over or a spread-over rule reads them from here, so a
 * change of word is one edit. The prepayments account and the month-end
 * close's prepaid schedule keep their accounting names.
 */
export const SPREAD_OVER_WORDS = {
  /** The Ledger rules tab, and what the line's setting is called. */
  name: "Spread over",
  /** A rules filter and column: does the rule spread its lines? */
  question: "Spread over?",
  /** The rule dialog's tick. */
  tick: "Spread over a period?",
  /** A rule that spreads its lines. */
  spread: "Spread",
  /** A rule that does not, and the default. */
  notSpread: "Not spread",
} as const;

/** How a spread-over rule's answer reads. */
export function spreadOverAnswer(isSpreadOver: boolean): string {
  return isSpreadOver ? SPREAD_OVER_WORDS.spread : SPREAD_OVER_WORDS.notSpread;
}
